import SearchLandingPage from '@/components/modules/Landing/SearchLandingPage';
import { searchLandingPages } from '@/content/searchLandingPages';

const EnergySolutionPage = () => <SearchLandingPage config={searchLandingPages.energy} />;

export default EnergySolutionPage;
